import { ILine } from '../../global';
import theme from '../../themes/CBB/theme';

export const lineRowHeight = 116;
export const stageTabHeight = 16;

export function shouldLineShowAddStageButton(line: ILine, onboarding: boolean) {
  return line.edit || onboarding;
}

export function getAddStageButtonWidth(line: ILine, onboarding: boolean) {
  if (shouldLineShowAddStageButton(line, onboarding)) {
    const buttonWidth = theme.spacing(4);
    const deviderWidth = 1;
    return buttonWidth + deviderWidth;
  }
  return 0;
}
